import type { Dispatch, SetStateAction } from "react";
import {
    type SrChatMessage,
    appendAssistant,
    chartsFromResponse,
    nameCandidatesFromResponse,
    toHistory,
} from "./sr-chat-types";

type ApiPost = (payload: Record<string, unknown>) => Promise<any>;

export const runTextSend = async (opts: {
    text: string;
    projectid: string;
    prior: SrChatMessage[];
    conversationId: string;
    postChat: ApiPost;
    setMessages: Dispatch<SetStateAction<SrChatMessage[]>>;
}) => {
    const userMsg: SrChatMessage = {
        id: `u-${Date.now()}`,
        role: "user",
        content: opts.text,
    };
    opts.setMessages((prev) => [...prev, userMsg]);
    try {
        const data = await opts.postChat({
            projectid: parseInt(opts.projectid, 10),
            message: opts.text,
            history: toHistory(opts.prior),
            conversation_id: opts.conversationId,
            debug: false,
        });
        appendAssistant(
            opts.setMessages,
            data?.reply?.trim() || "No reply received from the agent.",
            chartsFromResponse(data),
            nameCandidatesFromResponse(data)
        );
    } catch (err: any) {
        appendAssistant(
            opts.setMessages,
            err?.message || "Something went wrong talking to the SR agent."
        );
    }
};
